import { BrandLogoEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoSetEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoSetEventVO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly value: RoomBrandLogoSetEvent) {
    JsonSchemaValidator.assert(RoomBrandLogoSetEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandLogo"],
      properties: {
        roomId,
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoSetEvent {
  roomId: RoomId;
  brandLogo: BrandLogoEntity;
}
